import { render, staticRenderFns } from "./roomDetail.vue?vue&type=template&id=9629b1b6&scoped=true&"
import script from "./roomDetail.vue?vue&type=script&lang=js&"
export * from "./roomDetail.vue?vue&type=script&lang=js&"
import style0 from "./roomDetail.vue?vue&type=style&index=0&id=9629b1b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9629b1b6",
  null
  
)

export default component.exports